import { createBrowserRouter, Outlet } from "react-router-dom";
import { lazy, Suspense } from "react";
import { ApplicationLoadError, LoadingPage } from "@evolys/ui";
import { Providers } from "./providers";
import ErrorPage from "./pages/ErrorPage";

// Lazy load layouts
const DashboardLayout = lazy(() => import("./layouts/DashboardLayout"));
const AuthLayout = lazy(() => import("./layouts/AuthLayout"));

// Lazy load pages
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const DashboardDetailPage = lazy(() => import("./pages/DashboardDetailPage"));
const LoginPage = lazy(() => import("./pages/auth/LoginPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

function Lazy({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<LoadingPage />}>{children}</Suspense>;
}

function RootLayout() {
  return (
    <Providers>
      <Outlet />
    </Providers>
  );
}

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <ApplicationLoadError />,
    children: [
      {
        element: (
          <Lazy>
            <DashboardLayout />
          </Lazy>
        ),
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            element: (
              <Lazy>
                <DashboardPage />
              </Lazy>
            ),
          },
          {
            path: "dashboard",
            element: (
              <Lazy>
                <DashboardDetailPage />
              </Lazy>
            ),
          },
        ],
      },
      {
        element: (
          <Lazy>
            <AuthLayout />
          </Lazy>
        ),
        children: [
          {
            path: "login",
            element: (
              <Lazy>
                <LoginPage />
              </Lazy>
            ),
          },
        ],
      },
      {
        path: "*",
        element: (
          <Lazy>
            <NotFoundPage />
          </Lazy>
        ),
      },
    ],
  },
]);
